const english = {
  "inventory.Add": "Add",
  "inventory.Products": "Products",
  "inventory.Services": "Services",
  "inventory.Suppliers": "Suppliers",
  "inventory.Warehouses": "Warehouses",
  "inventory.Purchases": "Purchases",
  "inventory.Evaluation": "Evaluation",
  "inventory.AddItems": "Add Items",
  "inventory.Search": "Search...",
  "inventory.Filter": "Filter",
  "inventory.Filters": "Filters",
  "inventory.Close": "Close",
  "inventory.Edit": "Edit",
  "inventory.Create": "Create",
  "inventory.Cancel": "Cancel",
  "inventory.GoBack": "Go Back",
  "inventory.Actions": "Actions",
  "inventory.Action": "Action",
  "inventory.Name": "Name",
  "inventory.Description": "Description",
  "inventory.Code": "Code",
  "inventory.Barcode": "Barcode",
  "inventory.Category": "Category",
  "inventory.Categories": "Categories",
  "inventory.Quantity": "Quantity",
  "inventory.Product": "Product",
  "inventory.ProductName": "Product Name",
  "inventory.Service": "Service",
  "inventory.ServiceName": "Service Name",
  "inventory.Cost": "Cost",
  "inventory.Price": "Price",
  "inventory.RetailPrice": "Retail Price",
  "inventory.Supplier": "Supplier",
  "inventory.Warehouse": "Warehouse",
  "inventory.Manager": "Manager",
  "inventory.Status": "Status",
  "inventory.Reason": "Reason",
  "inventory.Date": "Date",
  "inventory.Loading": "Loading...",
  "inventory.AddProduct": "Add Product",
  "inventory.EditProducts": "Edit Products",
  "inventory.ChooseProduct": "Choose Product",
  "inventory.ChooseWarehouse": "Choose Warehouse",
  "inventory.ChooseCategory": "Choose Category",
  "inventory.ChooseSupplier": "Choose Supplier",
  "inventory.SelectProduct": "Select Product",
  "inventory.SelectWarehouse": "Select Warehouse",
  "inventory.SelectSupplier": "Select Supplier",
  "inventory.AddCategory": "Add Category",
  "inventory.EditCategory": "Edit Category",
  "inventory.TransferProducts": "Transfer Products",
  "inventory.FromWarehouse": "From Warehouse",
  "inventory.ToWarehouse": "To Warehouse",
  "inventory.SourceWarehouse": "Source Warehouse",
  "inventory.DestinationWarehouse": "Destination Warehouse",
  "inventory.LoadingProducts": "Loading products...",
  "inventory.QuantityForSelectedProduct": "Quantity for selected product",
  "inventory.AddService": "Add Service",
  "inventory.EditService": "Edit Service",
  "inventory.ReportCategory": "Report Category",
  "inventory.ReturnProduct": "Returned Product",
  "inventory.AccountHolder": "Account Holder",
  "inventory.Select": "Select...",
  "inventory.Account": "Account",
  "inventory.Fee": "Fee",
  "inventory.Contract": "Contract",
  "inventory.VAT": "VAT",
  "inventory.ProductCategory": "Product",
  "inventory.Resellers": "Resellers",
  "inventory.Active": "Active",
  "inventory.Inactive": "Inactive",
  "inventory.Status": "Status",
  "inventory.Unclassified": "Unclassified",
  "inventory.FirstName": "First Name",
  "inventory.LastName": "Last Name",
  "inventory.PhoneNumber": "Phone Number",
  "inventory.Phone": "Phone",
  "inventory.Company": "Company",
  "inventory.FullName": "Full Name",
  "inventory.AddSupplier": "Add Supplier",
  "inventory.EditSupplier": "Edit Supplier",
  "inventory.BalanceUsd": "Balance USD",
  "inventory.History": "History",
  "inventory.Statement": "Statement",
  "inventory.SupplierHistory": "Supplier History",
  "inventory.SupplierStatement": "Supplier Statement",
  "inventory.SupplierAccountStatement": "Supplier Account Statement",
  "inventory.LoadingSupplierHistory": "Loading supplier history",
  "inventory.HistoryCouldNotBeLoaded": "History could not be loaded",
  "inventory.TryAgain": "Try Again",
  "inventory.NoSupplierHistoryYet": "No supplier history yet",
  "inventory.NewestActivityFirst": "Newest activity first",
  "inventory.Previous": "Previous",
  "inventory.Next": "Next",
  "inventory.Currency": "Currency",
  "inventory.Contact": "Contact",
  "inventory.Request": "Request",
  "inventory.PurchasesDebit": "Purchases/Debit",
  "inventory.PaymentsCredit": "Payments/Credit",
  "inventory.EndingBalanceUsd": "Ending Balance USD",
  "inventory.AcceptedPurchases": "Accepted Purchases",
  "inventory.PrintStatement": "Print Statement",
  "inventory.IncomingTransferRequests": "Incoming Transfer Requests",
  "inventory.Pending": "Pending",
  "inventory.Approve": "Approve",
  "inventory.Reject": "Reject",
  "inventory.ProductsAndQuantities": "Products and Quantities",
  "inventory.ThisWarehouseHasNoProducts": "This warehouse has no products",
  "inventory.TransferReason": "Transfer Reason",
  "inventory.EnterTheReason": "Enter the reason...",
  "inventory.ApproveTransfer": "Approve Transfer",
  "inventory.RejectTransfer": "Reject Transfer",
  "inventory.AddWarehouse": "Add Warehouse",
  "inventory.EditWarehouse": "Edit Warehouse",
  "inventory.ViewAllRecords": "View All Records",
  "inventory.BelowMinimum": "Below Minimum",
  "inventory.ExportCSV": "Export CSV",
  "inventory.BelowMinimumTitle": "Products Below Minimum Quantity",
  "inventory.NeededQuantity": "Needed",
  "inventory.NoProductsBelowMinimum": "All warehouses are at or above their minimum quantities.",
  "inventory.BelowMinimumLoadFailed": "The below-minimum list could not be loaded.",
  "inventory.AllWarehouseRecords": "All Warehouse Records",
  "inventory.SearchAllRecords": "Search all records...",
  "inventory.NoTransferRecordsAreAvailable": "No transfer records are available.",
  "inventory.NoRecordsMatchYourSearch": "No records match your search.",
  "inventory.ChangeQuantity": "Change Quantity",
  "inventory.MinQuantity": "Min Quantity",
  "inventory.SetMinQuantity": "Set Minimum Quantity",
  "inventory.MinQuantityInvalid": "Enter a whole number of 0 or more.",
  "inventory.MinQuantitySaved": "minimum quantity set to",
  "inventory.MinQuantitySaveFailed": "The minimum quantity could not be saved.",
  "inventory.Save": "Save",
  "inventory.Saving": "Saving…",
  "inventory.Records": "Records",
  "inventory.TransferTo": "Transfer to",
  "inventory.CurrentQuantity": "Current Quantity",
  "inventory.Adjustment": "Adjustment",
  "inventory.Increase": "Increase",
  "inventory.Decrease": "Decrease",
  "inventory.Amount": "Amount",
  "inventory.InventoryEvaluations": "Inventory Evaluations",
  "inventory.StockOperator": "Stock Operator",
  "inventory.EvaluationDate": "Evaluation Date",
  "inventory.Report": "Report",
  "inventory.AddEvaluation": "Add Evaluation",
  "inventory.AllStatuses": "All Statuses",
  "inventory.Matched": "Matched",
  "inventory.Discrepancy": "Discrepancy",
  "inventory.LoadingWarehouseProducts": "Loading warehouse products...",
  "inventory.ThisWarehouseHasNoListedProducts": "This warehouse has no listed products.",
  "inventory.ExpectedQuantity": "Expected Quantity",
  "inventory.ActualQuantity": "Actual Quantity",
  "inventory.Difference": "Difference",
  "inventory.OptionalProductFoundButNotListed": "Optional: Product Found but Not Listed",
  "inventory.AddUnlistedProduct": "Add Unlisted Product",
  "inventory.EvaluationReport": "Evaluation Report",
  "inventory.LoadingEvaluationReport": "Loading evaluation report...",
  "inventory.Discrepancies": "Discrepancies",
  "inventory.SiteOrders": "Site Orders",
  "inventory.Refresh": "Refresh",
  "inventory.SearchSiteOrders": "Search Site Orders...",
  "inventory.Order": "Order",
  "inventory.Site": "Site",
  "inventory.Core": "Core",
  "inventory.SelectCore": "Select core...",
  "inventory.SiteOrCoreRequired": "Select either a site or a core, not both.",
  "inventory.AccountHolder": "Account Holder",
  "inventory.ReferenceTotal": "Reference Total",
  "inventory.Initiator": "Initiator",
  "inventory.Show": "Show",
  "inventory.LoadingSiteOrders": "Loading Site Orders...",
  "inventory.NoSiteOrdersFound": "No Site Orders found.",
  "inventory.SiteOrderDetails": "Site Order Details",
  "inventory.ReferenceUnitPrice": "Reference Unit Price",
  "inventory.CancelAndRestoreStock": "Cancel and Restore Stock",
  "inventory.AddSiteOrder": "Add Site Order",
  "inventory.ViewSiteOrders": "View Site Orders",
  "inventory.SelectSite": "Select site...",
  "inventory.SelectAccountHolder": "Select account holder...",
  "inventory.Available": "Available",
  "inventory.ReferencePrice": "Reference Price",
  "inventory.Remove": "Remove",
  "inventory.NoProductsHaveBeenAdded": "No products have been added.",
  "inventory.PrintReceipt": "Print Receipt",
  "inventory.DeliveryReceipt": "Delivery Receipt",
  "inventory.RefundReceipt": "Refund Receipt",
  "inventory.DeliveryReceipts": "Delivery Receipts",
  "inventory.NoDeliveryReceiptsHaveBeenRecorded": "No delivery receipts have been recorded.",
  "inventory.View": "View",
  "inventory.RequestAnOrder": "Request an Order",
  "inventory.TotalRequests": "Total requests",
  "inventory.ApprovedBy": "Approved By",
  "inventory.UnitPrices": "Unit Prices",
  "inventory.Orders": "Orders",
  "inventory.Requester": "Requester",
  "inventory.Created": "Created",
  "inventory.Delivered": "Delivered",
  "inventory.PartiallyDelivered": "Partially Delivered",
  "inventory.TotalUsd": "Total USD",
  "inventory.Received": "Received",
  "inventory.OrderTotal": "Order Total",
  "inventory.ReceiveItems": "Receive Items",
  "inventory.Receipts": "Receipts",
  "inventory.Inspect": "Inspect",
  "inventory.Notes": "Notes",
  "inventory.Confirm": "Confirm",
  "inventory.Transfer": "Transfer",
  "inventory.SelectStockOperator": "Select Stock Operator",
  "inventory.Saving": "Saving...",
};

const arabic = {
  "inventory.Add": "إضافة",
  "inventory.Products": "المنتجات",
  "inventory.Services": "الخدمات",
  "inventory.Suppliers": "المورّدون",
  "inventory.Warehouses": "المستودعات",
  "inventory.Purchases": "المشتريات",
  "inventory.Evaluation": "التقييم",
  "inventory.AddItems": "إضافة أصناف",
  "inventory.Search": "بحث...",
  "inventory.Filter": "تصفية",
  "inventory.Filters": "عوامل التصفية",
  "inventory.Close": "إغلاق",
  "inventory.Edit": "تعديل",
  "inventory.Create": "إنشاء",
  "inventory.Cancel": "إلغاء",
  "inventory.GoBack": "رجوع",
  "inventory.Actions": "الإجراءات",
  "inventory.Action": "الإجراء",
  "inventory.Name": "الاسم",
  "inventory.Description": "الوصف",
  "inventory.Code": "الرمز",
  "inventory.Barcode": "الرمز الشريطي",
  "inventory.Category": "الفئة",
  "inventory.Categories": "الفئات",
  "inventory.Quantity": "الكمية",
  "inventory.Product": "المنتج",
  "inventory.ProductName": "اسم المنتج",
  "inventory.Service": "الخدمة",
  "inventory.ServiceName": "اسم الخدمة",
  "inventory.Cost": "التكلفة",
  "inventory.Price": "السعر",
  "inventory.RetailPrice": "سعر التجزئة",
  "inventory.Supplier": "المورّد",
  "inventory.Warehouse": "المستودع",
  "inventory.Manager": "المدير",
  "inventory.Status": "الحالة",
  "inventory.Reason": "السبب",
  "inventory.Date": "التاريخ",
  "inventory.Loading": "جارٍ التحميل...",
  "inventory.AddProduct": "إضافة منتج",
  "inventory.EditProducts": "تعديل المنتجات",
  "inventory.ChooseProduct": "اختر منتجًا",
  "inventory.ChooseWarehouse": "اختر مستودعًا",
  "inventory.ChooseCategory": "اختر فئة",
  "inventory.ChooseSupplier": "اختر مورّدًا",
  "inventory.SelectProduct": "اختر منتجًا",
  "inventory.SelectWarehouse": "اختر مستودعًا...",
  "inventory.SelectSupplier": "اختر مورّدًا",
  "inventory.AddCategory": "إضافة فئة",
  "inventory.EditCategory": "تعديل الفئة",
  "inventory.TransferProducts": "نقل المنتجات",
  "inventory.FromWarehouse": "من المستودع",
  "inventory.ToWarehouse": "إلى المستودع",
  "inventory.SourceWarehouse": "المستودع المصدر",
  "inventory.DestinationWarehouse": "المستودع الوجهة",
  "inventory.LoadingProducts": "جارٍ تحميل المنتجات...",
  "inventory.QuantityForSelectedProduct": "كمية المنتج المحدد",
  "inventory.AddService": "إضافة خدمة",
  "inventory.EditService": "تعديل الخدمة",
  "inventory.ReportCategory": "فئة التقرير",
  "inventory.ReturnProduct": "المنتج المرتجع",
  "inventory.AccountHolder": "صاحب الحساب",
  "inventory.Select": "اختر...",
  "inventory.Account": "الحساب",
  "inventory.Fee": "الرسوم",
  "inventory.Contract": "عقد",
  "inventory.VAT": "ضريبة القيمة المضافة",
  "inventory.ProductCategory": "منتج",
  "inventory.Resellers": "الموزعون",
  "inventory.Active": "فعّال",
  "inventory.Inactive": "غير فعّال",
  "inventory.Status": "الحالة",
  "inventory.Unclassified": "غير مصنّف",
  "inventory.FirstName": "الاسم الأول",
  "inventory.LastName": "اسم العائلة",
  "inventory.PhoneNumber": "رقم الهاتف",
  "inventory.Phone": "الهاتف",
  "inventory.Company": "الشركة",
  "inventory.FullName": "الاسم الكامل",
  "inventory.AddSupplier": "إضافة مورّد",
  "inventory.EditSupplier": "تعديل المورّد",
  "inventory.BalanceUsd": "الرصيد (USD)",
  "inventory.History": "السجل",
  "inventory.Statement": "كشف الحساب",
  "inventory.SupplierHistory": "سجل المورّد",
  "inventory.SupplierStatement": "كشف حساب المورّد",
  "inventory.SupplierAccountStatement": "كشف حساب المورّد",
  "inventory.LoadingSupplierHistory": "جارٍ تحميل سجل المورّد",
  "inventory.HistoryCouldNotBeLoaded": "تعذّر تحميل السجل",
  "inventory.TryAgain": "إعادة المحاولة",
  "inventory.NoSupplierHistoryYet": "لا يوجد سجل للمورّد بعد",
  "inventory.NewestActivityFirst": "أحدث الأنشطة أولًا",
  "inventory.Previous": "السابق",
  "inventory.Next": "التالي",
  "inventory.Currency": "العملة",
  "inventory.Contact": "جهة الاتصال",
  "inventory.Request": "طلب الشراء",
  "inventory.PurchasesDebit": "المشتريات/المدين",
  "inventory.PaymentsCredit": "المدفوعات/الدائن",
  "inventory.EndingBalanceUsd": "الرصيد الختامي (USD)",
  "inventory.AcceptedPurchases": "المشتريات المقبولة",
  "inventory.PrintStatement": "طباعة الكشف",
  "inventory.IncomingTransferRequests": "طلبات التحويل الواردة",
  "inventory.Pending": "قيد الانتظار",
  "inventory.Approve": "موافقة",
  "inventory.Reject": "رفض",
  "inventory.ProductsAndQuantities": "المنتجات والكميات",
  "inventory.ThisWarehouseHasNoProducts": "لا توجد منتجات في هذا المستودع",
  "inventory.TransferReason": "سبب التحويل",
  "inventory.EnterTheReason": "أدخل سبب هذا التحويل...",
  "inventory.ApproveTransfer": "الموافقة على التحويل",
  "inventory.RejectTransfer": "رفض التحويل",
  "inventory.AddWarehouse": "إضافة مستودع",
  "inventory.EditWarehouse": "تعديل المستودع",
  "inventory.ViewAllRecords": "عرض جميع السجلات",
  "inventory.BelowMinimum": "تحت الحد الأدنى",
  "inventory.ExportCSV": "تصدير CSV",
  "inventory.BelowMinimumTitle": "منتجات تحت الحد الأدنى للكمية",
  "inventory.NeededQuantity": "الكمية المطلوبة",
  "inventory.NoProductsBelowMinimum": "جميع المستودعات عند الحد الأدنى للكمية أو أعلى.",
  "inventory.BelowMinimumLoadFailed": "تعذّر تحميل قائمة المنتجات تحت الحد الأدنى.",
  "inventory.AllWarehouseRecords": "جميع سجلات المستودع",
  "inventory.SearchAllRecords": "البحث في جميع السجلات...",
  "inventory.NoTransferRecordsAreAvailable": "لا تتوفر سجلات تحويل.",
  "inventory.NoRecordsMatchYourSearch": "لا توجد سجلات تطابق بحثك.",
  "inventory.ChangeQuantity": "تغيير الكمية",
  "inventory.MinQuantity": "الحد الأدنى للكمية",
  "inventory.SetMinQuantity": "تحديد الحد الأدنى للكمية",
  "inventory.MinQuantityInvalid": "أدخل عددًا صحيحًا يساوي 0 أو أكثر.",
  "inventory.MinQuantitySaved": "تم تحديد الحد الأدنى للكمية إلى",
  "inventory.MinQuantitySaveFailed": "تعذّر حفظ الحد الأدنى للكمية.",
  "inventory.Save": "حفظ",
  "inventory.Saving": "جارٍ الحفظ…",
  "inventory.Records": "السجلات",
  "inventory.TransferTo": "التحويل إلى",
  "inventory.CurrentQuantity": "الكمية الحالية",
  "inventory.Adjustment": "التسوية",
  "inventory.Increase": "زيادة",
  "inventory.Decrease": "نقصان",
  "inventory.Amount": "المقدار",
  "inventory.InventoryEvaluations": "تقييمات المخزون",
  "inventory.StockOperator": "مسؤول المخزون",
  "inventory.EvaluationDate": "تاريخ التقييم",
  "inventory.Report": "التقرير",
  "inventory.AddEvaluation": "إضافة تقييم",
  "inventory.AllStatuses": "كل الحالات",
  "inventory.Matched": "متطابق",
  "inventory.Discrepancy": "وجود فرق",
  "inventory.LoadingWarehouseProducts": "جارٍ تحميل منتجات المستودع...",
  "inventory.ThisWarehouseHasNoListedProducts": "لا توجد منتجات مُدرجة لهذا المستودع.",
  "inventory.ExpectedQuantity": "الكمية المتوقعة",
  "inventory.ActualQuantity": "الكمية الفعلية",
  "inventory.Difference": "الفرق",
  "inventory.OptionalProductFoundButNotListed": "اختياري: منتج موجود لكنه غير مُدرج",
  "inventory.AddUnlistedProduct": "إضافة منتج غير مُدرج",
  "inventory.EvaluationReport": "تقرير التقييم",
  "inventory.LoadingEvaluationReport": "جارٍ تحميل تقرير التقييم...",
  "inventory.Discrepancies": "الفروقات",
  "inventory.SiteOrders": "طلبات المواقع",
  "inventory.Refresh": "تحديث",
  "inventory.SearchSiteOrders": "البحث في طلبات المواقع...",
  "inventory.Order": "الطلب",
  "inventory.Site": "الموقع",
  "inventory.Core": "الكور",
  "inventory.SelectCore": "اختر الكور...",
  "inventory.SiteOrCoreRequired": "اختر إما موقعًا أو كورًا، وليس كليهما.",
  "inventory.AccountHolder": "صاحب الحساب",
  "inventory.ReferenceTotal": "الإجمالي المرجعي",
  "inventory.Initiator": "مُنشئ الطلب",
  "inventory.Show": "عرض",
  "inventory.LoadingSiteOrders": "جارٍ تحميل طلبات المواقع...",
  "inventory.NoSiteOrdersFound": "لم يتم العثور على طلبات مواقع.",
  "inventory.SiteOrderDetails": "تفاصيل طلب الموقع",
  "inventory.ReferenceUnitPrice": "سعر الوحدة المرجعي",
  "inventory.CancelAndRestoreStock": "إلغاء الطلب وإعادة المخزون",
  "inventory.AddSiteOrder": "إضافة طلب موقع",
  "inventory.ViewSiteOrders": "عرض طلبات المواقع",
  "inventory.SelectSite": "اختر موقعًا...",
  "inventory.SelectAccountHolder": "اختر صاحب حساب...",
  "inventory.Available": "المتاح",
  "inventory.ReferencePrice": "السعر المرجعي",
  "inventory.Remove": "إزالة",
  "inventory.NoProductsHaveBeenAdded": "لم تتم إضافة أي منتجات.",
  "inventory.PrintReceipt": "طباعة الإيصال",
  "inventory.DeliveryReceipt": "إيصال التسليم",
  "inventory.RefundReceipt": "إيصال الاسترداد",
  "inventory.DeliveryReceipts": "إيصالات التسليم",
  "inventory.NoDeliveryReceiptsHaveBeenRecorded": "لم تُسجّل إيصالات تسليم.",
  "inventory.View": "عرض",
  "inventory.RequestAnOrder": "إنشاء طلب شراء",
  "inventory.TotalRequests": "إجمالي الطلبات",
  "inventory.ApprovedBy": "تمت الموافقة بواسطة",
  "inventory.UnitPrices": "أسعار الوحدات",
  "inventory.Orders": "الطلبات",
  "inventory.Requester": "مُنشئ الطلب",
  "inventory.Created": "تاريخ الإنشاء",
  "inventory.Delivered": "تم التسليم",
  "inventory.PartiallyDelivered": "تم التسليم جزئيًا",
  "inventory.TotalUsd": "الإجمالي (USD)",
  "inventory.Received": "المستلم",
  "inventory.OrderTotal": "إجمالي الطلب",
  "inventory.ReceiveItems": "استلام الأصناف",
  "inventory.Receipts": "الإيصالات",
  "inventory.Inspect": "فحص",
  "inventory.Notes": "ملاحظات",
  "inventory.Confirm": "تأكيد",
  "inventory.Transfer": "نقل",
  "inventory.SelectStockOperator": "اختر مسؤول المخزون",
  "inventory.Saving": "جارٍ الحفظ...",
};

const INVENTORY_LANGUAGE_REFRESH = true;

if (
  typeof window !== "undefined" &&
  window.location.pathname.startsWith(
    "/inventory"
  )
) {
  let currentLanguage =
    localStorage.getItem("ossLanguage") ===
    "ar"
      ? "ar"
      : "en";

  const languageObserver =
    new MutationObserver(() => {
      const nextLanguage =
        document.documentElement.lang ===
        "ar"
          ? "ar"
          : "en";

      if (
        nextLanguage !== currentLanguage
      ) {
        currentLanguage = nextLanguage;
        window.location.reload();
      }
    });

  languageObserver.observe(
    document.documentElement,
    {
      attributes: true,
      attributeFilter: ["lang"],
    }
  );
}

export function inventoryLocalizedName(nameEn, nameAr) {
  const language = document.documentElement.lang;
  const value = language === "ar" ? nameAr : nameEn;
  return value || "";
}

export default function inventoryText(key) {
  const language = document.documentElement.lang;
  const values = language === "ar" ? arabic : english;
  return values[key] || key;
}
